import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href = 'https://infoproductossoluciones.com/cart/48108408078592:1'
}: CTAButtonProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} className={`
        inline-block bg-brand-gold text-white font-bold py-4 px-8 rounded-full 
        shadow-gold-glow hover:shadow-gold-glow-hover hover:-translate-y-1
        transition-all duration-300 uppercase tracking-wider text-sm md:text-base
        text-center cursor-pointer
        ${className}
      `} data-id="element-148">
      {children}
    </a>;
}